// @flow
'use strict'

const identity_ = require('lodash/identity')
const mergeWith_ = require('lodash/mergeWith')
const pull_ = require('lodash/pull')
const mapValues_ = require('lodash/mapValues')
const omit_ = require('lodash/omit')
const has_ = require('lodash/has')

/*::
import typeof Raven from 'raven-js'

import type { RavenProxyCreator } from './types'
*/

const retry = (Raven, ravenFunction /*: $Keys<Raven> */) => (...args) => {
  try {
    // prettier-ignore
    (Raven /*: Object */)[ravenFunction](...args)
  } catch (e) {
    try {
      // prettier-ignore
      (Raven /*: Object */)[ravenFunction](
        `Failed on ${ravenFunction}. Got exception: ${e.name} - ${e.message}`,
        {
          extra: {
            'original-error': JSON.stringify(args)
          }
        }
      )
    } catch (e) {
      // well... we really have nothing to do here :(
    }
  }
}

const removeRecordsIfExists = value =>
  has_(value, 'state.records') ? omit_(value, 'state.records') : value

const removeUserData = data => mapValues_(data, removeRecordsIfExists)

const ravenProxyCreator /*: RavenProxyCreator */ = sourceRaven => {
  const callbacks = []

  sourceRaven.setDataCallback((data, originalCallback = identity_) => {
    callbacks.forEach(cb =>
      mergeWith_(data.extra, cb(), (objValue, srcValue) => {
        // We customize the serializer because of this bug:
        // https://github.com/origamitower/folktale/issues/190
        if (srcValue && srcValue[Symbol.for('@@folktale:adt:tag')]) {
          return srcValue.toJSON()
        }
      })
    )
    const finalData = originalCallback(data)
    finalData.extra = removeUserData(finalData.extra)

    return finalData
  })

  const proxy = {
    addDataCallback: (cb /*: Function */) => {
      callbacks.push(cb)
      return () => {
        pull_(callbacks, cb)
      }
    }
  }
  const wrappedRaven = Object.assign({}, sourceRaven, {
    setUserContext: (...args /*: Array<*> */) =>
      sourceRaven.setUserContext(...args),
    captureBreadcrumb: (...args /*: Array<*> */) =>
      sourceRaven.captureBreadcrumb(...args),
    captureException: (...args /*: Array<*> */) =>
      retry(sourceRaven, 'captureException')(...args),
    captureMessage: (...args /*: Array<*> */) =>
      retry(sourceRaven, 'captureMessage')(...args)
  })

  return Object.assign({}, wrappedRaven, proxy)
}

module.exports = ravenProxyCreator



// WEBPACK FOOTER //
// ./raven/ravenProxy.js